import { Grid, styled } from '@mui/material';

const Item = styled(Grid)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  boxShadow: theme.borderStyles.cardBorders,
  borderRadius: '5px',
  display: 'flex',
  justifyContent: 'space-between',
}));

export default Item;
